<mat-chip-list *ngIf="items?.length">
  <mat-chip *ngFor="let item of items"
            [removable]="true"
            (removed)="onItemRemove(item)">
    {{displayMethod ? displayMethod(item) : item[displayKey]}}
    <mat-icon matChipRemove>cancel</mat-icon>
  </mat-chip>
</mat-chip-list>
